import React, { useState } from "react";
import PropTypes from "prop-types"; // Import PropTypes
import Modal from "react-bootstrap/Modal";
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";

const AddSupplierPayment = ({ props, handleClose, show }) => {
  const [paymentType, setPaymentType] = useState([]);
  const [backendSuccess, setBackendSuccess] = useState(null);
  const [backendErrors, setBackendErrors] = useState({});
       let season_id = localStorage.getItem("season_id");

  console.log(props); 

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
 
  const defaultDate = formatDate(new Date());

  const [formData, setFormData] = useState({
    season_id: season_id,
    supplier: props,
    date: defaultDate,
    amount: "",
    operation: "",
    payment_type: "",
    note: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setBackendErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };

  const customOperationInput = (e) => {
    if (e.target.value === "2" || e.target.value === "3") {
      setPaymentType([
        { id: 1, text: "Bank Transfer" },
        { id: 2, text: "Cash" },
        { id: 3, text: "Cheque" },
      ]);
    } else {
      setPaymentType([]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("/supplier-balances/add-payment", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          setTimeout(() => {
            window.location.href = "/supplier-balances-detail/" + props;
          }, 500);
        } else {
          setBackendErrors(response.data.error || {});
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const customHandleInput = (event) => {
    const inputName = event.target.name;
    setBackendErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[inputName];
      return newErrors;
    });
  };

  return (
    <>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header>
          <h4 className="modal-title">Add Supplier Payment</h4>
          <button
            type="button"
            className="close"
            data-bs-dismiss="modal"
            onClick={handleClose}
            aria-hidden="true"
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            {backendSuccess && (
              <div className="from-success mt-1">{backendSuccess}</div>
            )}

            <div className="form-group">
              <label>Date</label>
              <input
                className="form-control form-white"
                type="date"
                name="date"
                value={formData.date}
                onChange={(e) => {
                  handleChange(e);
                  customHandleInput(e);
                }}
              />
              {backendErrors.date && (
                <small className="form-error mt-1">{backendErrors.date}</small>
              )}
            </div>

            <div className="form-group">
              <label>Amount</label>
              <input
                className="form-control form-white"
                type="text"
                name="amount"
                value={formData.amount}
                onChange={(e) => {
                  handleChange(e);
                  customHandleInput(e);
                }}
                onKeyPress={(event) => {
                  if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                    event.preventDefault();
                  }
                }}
              />
              {backendErrors.amount && (
                <small className="form-error mt-1">{backendErrors.amount}</small>
              )}
            </div>

            <div className="form-group">
              <label>Select Operation</label>
              <select
                className="form-control form-white"
                name="operation"
                value={formData.operation}
                onChange={(e) => {
                  handleChange(e);
                  customHandleInput(e);
                  customOperationInput(e);
                }}
              >
                <option value="">Select</option>
                <option value="1">Solde</option>
                <option value="2">Avance</option>
                <option value="3">Payment</option>
              </select>
              {backendErrors.operation && (
                <small className="form-error mt-1">{backendErrors.operation}</small>
              )}
            </div>

            {paymentType.length > 0 && (
              <div className="form-group">
                <label>Select Payment Type</label>
                <select
                  className="form-control form-white"
                  name="payment_type"
                  value={formData.payment_type}
                  onChange={(e) => {
                    handleChange(e);
                    customHandleInput(e);
                  }}
                >
                  <option value="">Select</option>
                  {paymentType.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.text}
                    </option>
                  ))}
                </select>
                {backendErrors.payment_type && (
                  <small className="form-error mt-1">{backendErrors.payment_type}</small>
                )}
              </div>
            )}

            <div className="form-group">
              <label>Note:</label>
              <textarea
                className="form-control form-white"
                name="note"
                value={formData.note}
                onChange={(e) => {
                  handleChange(e);
                  customHandleInput(e);
                }}
              ></textarea>
              {backendErrors.note && (
                <small className="form-error mt-1">{backendErrors.note}</small>
              )}
            </div>

            <div className="submit-section">
              <button type="submit" className="btn btn-primary submit-btn">
                SUBMIT
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

// **Prop Type Validation**
AddSupplierPayment.propTypes = {
  props: PropTypes.any.isRequired, // If props is an object, use PropTypes.object
  handleClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default AddSupplierPayment;
